import React from "react";
import ReactApexChart from "react-apexcharts";
import { useNavigate } from "react-router-dom";
const BusinessChartComponent = ({ businessTypes, formState }) => {

  const navigation = useNavigate();

  const handleBarClick = (category) => {
   
    formState.key = encodeURIComponent(category);
    formState.category = 'business';
    navigation(`/dashboard-count-list`, { state: formState });
  }


  const categories = businessTypes?.map((item) => item.name + ` (${item.people_count})`);
  const data = businessTypes?.map((item) => item.people_count);
  const chartData = {
    series: [
      {
        name: "",
        data,
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
        toolbar: {
          show: false,
        },
        events: {
          dataPointSelection: function (event, chartContext, config) {
            const index = config.dataPointIndex;
            const category = config.w.globals.labels[index];
            const cleanCategory = category.replace(/\(\d+\)/, "").trim();
            handleBarClick(cleanCategory);
          }
        }
      },

      plotOptions: {
        bar: {
          borderRadius: 0,
          horizontal: true,
          distributed: true,
          barHeight: "80%",
          isFunnel: true,
        },
      },

      colors: ["#F44F5E", "#E55A89", "#D863B1", "#CA6CD8", "#B57BED", "#8D95EB", "#62ACEA", "#4BC3E6"],

      dataLabels: {
        enabled: true,
        formatter: function (val, opt) {
          return opt.w.globals.labels[opt.dataPointIndex];
        },
        dropShadow: {
          enabled: true,
        },
      },

      title: {
        text: "Business Startups",
        align: "middle",
      },

      xaxis: {
        categories,
      },

      legend: {
        show: false,
      },
    },
  };


  return (
    <div>
      <div id="chart">
        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type="bar"
          height={350}
        />
      </div>
      <div id="html-dist"></div>
    </div>
  );
};

export default BusinessChartComponent;
